"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _create = _interopRequireDefault(require("../utils/create"));

var _default = (0, _create.default)({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      class: _vm.b()
    }, [_c('ul', {
      staticClass: "van-hairline--surround",
      class: _vm.b('security'),
      on: {
        "touchstart": function touchstart($event) {
          $event.stopPropagation();

          _vm.$emit('focus');
        }
      }
    }, _vm._l(_vm.points, function (visibility) {
      return _c('li', {
        staticClass: "van-hairline"
      }, [_c('i', {
        style: "visibility: " + visibility
      })]);
    }), 0), _vm.errorInfo || _vm.info ? _c('div', {
      class: _vm.b(_vm.errorInfo ? 'error-info' : 'info'),
      domProps: {
        "textContent": _vm._s(_vm.errorInfo || _vm.info)
      }
    }) : _vm._e()]);
  },
  name: 'password-input',
  props: {
    info: String,
    errorInfo: String,
    value: {
      type: String,
      default: ''
    },
    length: {
      type: Number,
      default: 6
    }
  },
  computed: {
    points: function points() {
      var arr = [];

      for (var i = 0; i < this.length; i++) {
        arr[i] = this.value[i] ? 'visible' : 'hidden';
      }

      return arr;
    }
  }
});

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/vant/lib/password-input/index.js
// module id = 628
// module chunks = 1